const config = {
  ENV: import.meta.env.MODE,
  spreedlyKey:
    import.meta.env.VITE_SPREEDLY_ENVIRONMENT_KEY ||
    "MbskPSZ9MMH7vnuAItHyGdqotHe",
  googleMapsApiKey: import.meta.env.VITE_REACT_APP_GOOGLE_MAPS_API_KEY,
  REACT_APP_VERSION: import.meta.env.VITE_REACT_APP_VERSION,
  UBER_URL: import.meta.env.VITE_UBER_URL,
  MOCK: import.meta.env.VITE_MOCK === "true",
  kustomerApiKey: import.meta.env.VITE_KUSTOMER_API_KEY,
  kustomerBrandId: import.meta.env.VITE_KUSTOMER_BRAND_ID,
  kustomerChatSupport: import.meta.env.VITE_KUSTOMER_CHAT_SUPPORT,
};

export default config;
